import { createSlider } from "../components/slider";

createSlider("#catalogs");
